export const FE_WWW_GUIDE_NEW = 'fe_www_guide_4_new';
export const HAS_CLOSE = 'hasClose';